module.exports = __webpack_public_path__ + "img/20200113160620422.c9c509b5.jpg";